module.exports = __webpack_public_path__ + "img/Services-illust.6eb5f17b.svg";